function openCartDrawer() {
    document.querySelector(".cart-overlay").classList.add("active");
    document.querySelector(".cart-drawer").classList.add("active");
  }
  
  function closeCartDrawer() {
    document.querySelector(".cart-overlay").classList.remove("active");
    document.querySelector(".cart-drawer").classList.remove("active");
  }
  
  function closeCartDrawerListner() {
    document.querySelectorAll(".cart-drawer .close, .cart-overlay").forEach(el => {
      el.addEventListener("click", () => {
        closeCartDrawer()
      })
    })
  }
  
  async function removeCartItem(key) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),  // Set quantity to 0 to remove the item
      });
  
      if (res.ok) {
        const json = await res.json();
        console.log("Item removed from cart:", json);
        await updateCartDrawer();  // Re-update the cart drawer after removal
      } else {
        const errorJson = await res.json();
        console.error('Failed to remove item from cart:', errorJson);
      }
    } catch (error) {
      console.error('Error removing item from cart:', error);
    }
  }
  
  async function updateCartDrawer() {
    const res = await fetch("/?section_id=cart-drawer"); 
    const text = await res.text()
    const html  = document.createElement('div')
    html.innerHTML = text;
  
    const newBox = html.querySelector('.cart-drawer').innerHTML;
  
    document.querySelector('.cart-drawer').innerHTML = newBox;
  
    addCartDrawerQuantities();
    addCartDrawerRemoveListeners();
    closeCartDrawerListner();
    upsellAddtoCartListener();
  }
  
  // Add event listeners for removing items from the cart
  function addCartDrawerRemoveListeners() {
    document.querySelectorAll(".trash").forEach((trashButton) => {
      trashButton.addEventListener("click", async (e) => {
        e.preventDefault();
        const key = trashButton.parentElement.getAttribute("data-line-item-key");
        await removeCartItem(key);  // Pass the key of the item to remove
      });
    });
  }
  
  // Update quantities
  function addCartDrawerQuantities() {
    const buttons = document.querySelectorAll('.product-actions .counter button');
  
    for (const button of buttons) {
      button.addEventListener("click", async () => {
        const rootProduct = button.parentElement.parentElement.parentElement.parentElement // Use closest to find the root product
        console.log(rootProduct);
  
        const key = rootProduct.getAttribute("data-line-item-key");
        const currentQuantity = Number(button.parentElement.querySelector("input").value);
        const isAdd = button.classList.contains("counter-plus");
        const newQuantity = isAdd ? currentQuantity + 1 : currentQuantity - 1;
  
        // Prevent negative quantities
        if (newQuantity < 0) return;
  
        try {
          const res = await fetch('/cart/update.js', {
            method: 'post',
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: newQuantity } })
          });
  
          if (res.ok) {
            const json = await res.json();
            // Optionally handle the response here
            console.log(json);
            // Update the cart drawer after a successful update
            await updateCartDrawer();
          } else {
            console.error('Failed to update cart:', await res.json());
          }
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      });
    }
  }
  
    
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        try {
          const response = await fetch("/cart/add", {
            method: "post",
            body: new FormData(form),
          });
    
          if (response.ok) {
            // Update Cart
            await updateCartDrawer();
    
            // Open Cart
            openCartDrawer();
          } else {
            throw new Error('Failed to add item to cart');
          }
        } catch (error) {
          console.error(error);
        }
      });
    });
  
    document.querySelectorAll("a[href='/cart'], .payment-buttons button").forEach((a) => {
      a.addEventListener("submit", (e) => {
        e.preventDefault();
        // Open cart drawer
        openCartDrawer();
      })
    });
    
  
  document.querySelectorAll("a[href='/cart']").forEach((a) => {
    a.addEventListener("click", (e) => {
      // Check if the clicked element is within the cart drawer footer
      if (a.closest(".cart-drawer__footer")) {
        return; // Skip the drawer opening for excluded elements
      }
  
      e.preventDefault();
      
      // If on the cart page, refresh the page
      if (window.location.pathname === "/cart") {
        console.log("Already on the cart page. Refreshing...");
        location.reload(); // Refresh the page
        return;
      }
  
      // Otherwise, open the cart drawer
      openCartDrawer();
    });
  });
  
  // Handle removing items from the cart drawer
  document.querySelectorAll(".trash").forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      
      // Get the line item key for the cart item
      const key = button.parentElement.getAttribute('data-line-item-key');
      
      // Call the removeCartItem function with the key
      await removeCartItem(key);
      
      // Re-update the cart drawer
      await updateCartDrawer();
    });
  });
  
  function upsellAddtoCartListener() {
    // Get all upsell items and buttons
    const upsellSection = document.querySelector('.upsell-products');
    const upsellButtons = document.querySelectorAll('.upsell-add-button');
    
    // Function to check if a specific upsell product is in the cart
    async function checkCartForUpsell() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        let allAdded = true;
  
        // Loop through all upsell buttons and check if the product is in the cart
        upsellButtons.forEach(button => {
          const upsellProductVariantId = button.getAttribute('data-variant-id');
          const isUpsellInCart = cart.items.some(item => item.variant_id == upsellProductVariantId);
  
          const upsellItem = button.closest('.upsell-item');
  
          // Show or hide the upsell item based on whether it's in the cart
          if (isUpsellInCart) {
            upsellItem.classList.add('added'); // Hide the upsell item
          } else {
            upsellItem.classList.remove('added'); // Show the upsell item
            allAdded = false; // Not all items are added yet
          }
        });
  
        // If all upsell items are added, hide the entire upsell section
        if (allAdded) {
          upsellSection.classList.remove('active');// Optionally hide upsell section
        } else {
          upsellSection.classList.add('active');
        }
  
      } catch (error) {
        console.error('Error checking cart contents:', error);
      }
    }
  
    // Function to add upsell item to the cart
    async function addUpsellToCart(variantId) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
  
        if (response.ok) {
          const data = await response.json();
          console.log('Product added:', data);
  
          // Refresh the cart drawer or other cart updates
          if (typeof updateCartDrawer === 'function') {
            await updateCartDrawer();
          }
  
          // Recheck the cart for upsell items
          await checkCartForUpsell();
        } else {
          const errorData = await response.json();
          console.error('Failed to add product:', errorData);
          alert('Failed to add product. Please try again.');
        }
      } catch (error) {
        console.error('Error adding upsell product:', error);
        alert('Error adding product to cart.');
      }
    }
  
    // Attach click event to each upsell button
    upsellButtons.forEach(button => {
      const variantId = button.getAttribute('data-variant-id');
      if (variantId) {
        button.addEventListener('click', async () => {
          await addUpsellToCart(variantId);
        });
      }
    });
  
    // Check cart contents on page load
    checkCartForUpsell();
  
    // Optionally, recheck when cart updates
    document.addEventListener('cart:updated', checkCartForUpsell);
  }
  
  document.querySelector('.checkout a').addEventListener('click', (e) => {
    e.preventDefault();
    
    window.location.href = '/checkout';
  });
  
  addCartDrawerQuantities();
  addCartDrawerRemoveListeners(); 
  closeCartDrawerListner();
  upsellAddtoCartListener()
  
  